import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WeekSelector.html?raw';

import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import "../../moreCore/UI/SelectBox/SelectBox";

import "../../moreCore/UI/RadioGroup/RadioGroup";
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';



interface Entity_Calendarweek {
    ID: string;
    Classname: string;
    calendarweek_txt_short: string;
    calendarweek_txt_long: string;
    calendarweek_int: number;
    ref_sys_year: {
        year_txt: string;
    }
    ref_sys_day_start: {
        day_date: string
    }
    ref_sys_day_end: {
        day_date: string
    }
}

interface Entity_Year {
    ID: string;
    Classname: string;
    year_txt: string;
    year: number
}

interface Entity_Month {
    ID: string;
    month_int: number;
    month_txt: string;
    month_date: number
}

interface RgbColor {
    Hex: string;
    IsNull: boolean;
    Red: number;
    Green: number;
    Blue: number;
}

interface PitColor {
    BackColor: RgbColor;
    TextColor: RgbColor;
}

interface Entity_FunctionalGroup {
    ID: string;
    code: string;
    description: string;
    order: number;
    coloration?: PitColor;
}
class WeekSelector extends compose(_WidgetBaseSP) {
    templateString: any = template;

    SelectBox_year: MdsLax<InstanceType<typeof SelectBox>>;
    SelectBox_week: MdsLax<InstanceType<typeof SelectBox>>;
    SelectBox_month: MdsLax<InstanceType<typeof SelectBox>>;
    SelectBox_functionalGroups: MdsLax<InstanceType<typeof SelectBox>>;
    RadioGroup_timeFilterMode: MdsLax<InstanceType<typeof RadioGroup>>;
    years: Array<Entity_Year>;
    functionalGroups: Array<Entity_FunctionalGroup>;
    directBookingId: string;
    directProjectId: string;
    timeBasedFilterContainer: HTMLDivElement;

    constructor(directBookingId?: string, directProjectId?: string) {
        super(...(arguments as unknown as []));
        this.directBookingId = directBookingId;
        this.directProjectId = directProjectId;
    }

    _onChange_Year() {
        let yearId = this.SelectBox_year.getValue();
        localStorage.setItem("lastselected__year", yearId);

        this.loadWeeks();
        this.loadMonths();
    }

    _onChange_Week() {
        localStorage.setItem("lastselected__week", this.SelectBox_week.getValue());
    }

    _onChange_RadioGroup_timeFilterMode(): void {
        let filterMode: string = this.RadioGroup_timeFilterMode.getValue() as string;
        //console.log(filterMode);

        if (filterMode == "weeks") {
            this.UiModder.domClass.remove(this.SelectBox_week.domNode.parentNode, "w3-hide");
            this.UiModder.domClass.add(this.SelectBox_month.domNode.parentNode, "w3-hide");
        } else if (filterMode == "month") {
            this.UiModder.domClass.add(this.SelectBox_week.domNode.parentNode, "w3-hide");
            this.UiModder.domClass.remove(this.SelectBox_month.domNode.parentNode, "w3-hide");
        }
    }

    // #region Weeks
    loadWeeks(): void {
        this.StandbyStart();

        let year: string = null;
        let yearId: string = this.SelectBox_year.getValue();
        if (yearId != null && this.years != null) {
            for (var yearEntity of this.years) {
                if (yearEntity.ID == yearId) {
                    year = yearEntity.year_txt;
                }
            }

            let url = window.appRoot + "data/calendarweeks";
            this.RequestManager.post(
                url,
                {
                    "JsonData": JSON.stringify({
                        "year": year
                    })
                },
                lang.hitch(this, this.loadWeeks_Response),
                lang.hitch(this, this.loadWeeks_Error)
            );
        }
    }

    loadWeeks_Response(calendarweeks: Array<Entity_Calendarweek>): void {
        this.StandbyStop();
        console.log("loadWeeks_Response", calendarweeks);
        this._renderWeeks(calendarweeks);
    }

    loadWeeks_Error(error): void {
        this.StandbyStop();
    }

    _renderWeeks(calendarweeks: Array<Entity_Calendarweek>): void {
        let weekSelectParent: Node = this.SelectBox_week.domNode.parentNode;

        this.SelectBox_week.destroy();
        this.SelectBox_week = new SelectBox();
        this.SelectBox_week.setLabel(this.getTranslation("OM_Matrix__lbl_Week"));
        this.SelectBox_week.setBlankOption("XXX", this.getTranslation("OM_Matrix__lbl_SelectWeek"));
        this.SelectBox_week.setMultiselectHeight(8);
        this.SelectBox_week.minCount = 1;
        this.SelectBox_week.maxCount = 8;
        this.SelectBox_week.setMultiselect(true);
        this.SelectBox_week.placeAt(weekSelectParent);
        this.SelectBox_week.on("valueChange", lang.hitch(this, this._onChange_Week));

        let currentWeekNumber = this.getWeekNumber(new Date());
        let currentWeekID = null;

        for (let weekEntity of calendarweeks) {
            if (weekEntity.calendarweek_int > 0) {
                if (weekEntity.calendarweek_int == currentWeekNumber && weekEntity.ref_sys_year.year_txt == new Date().getFullYear().toString()) {
                    currentWeekID = weekEntity.ID;
                    this.SelectBox_week.addEntry("currentWeek", this.getTranslation("OM_Matrix__lbl_CurrentWeek"), false);
                }
                this.SelectBox_week.addEntry(weekEntity.ID, weekEntity.calendarweek_int.toString() + " (" + weekEntity.ref_sys_day_start.day_date + " - " + weekEntity.ref_sys_day_end.day_date + ")");

            }
        }

        let lastSelected = localStorage.getItem("lastselected__week");
        if (typeof (lastSelected) == "string" && lastSelected.length >= 17) { // mindestens eine ID. oder mehrfach..
            this.SelectBox_week.setMultipleValues(lastSelected.split(","));
        } else {
            if (currentWeekID != null) {
                this.SelectBox_week.setValue(currentWeekID);
            }
        }

        this.SelectBox_week.startup();
    }
    // #endregion

    // #region years
    loadYears(): void {
        this.StandbyStart();

        let url = window.appRoot + "data/years";
        this.RequestManager.post(
            url,
            {
                "JsonData": JSON.stringify({

                })
            },
            lang.hitch(this, this.loadYears_Response),
            lang.hitch(this, this.loadYears_Error)
        );
    }

    loadYears_Response(years: Array<Entity_Year>): void {
        this.StandbyStop();
        this.years = years;
        console.log("loadYears_Response", years);
        this._renderYears(years);
    }

    loadYears_Error(error): void {
        this.StandbyStop();
    }

    _renderYears(years: Array<Entity_Year>): void {
        let SelectParent: Node = this.SelectBox_year.domNode.parentNode;

        this.SelectBox_year.destroy();
        this.SelectBox_year = new SelectBox();
        this.SelectBox_year.setLabel(this.getTranslation("OM_Matrix__lbl_Year"));
        this.SelectBox_year.placeAt(SelectParent);
        this.SelectBox_year.on("valueChange", lang.hitch(this, "_onChange_Year"));

        let currentYearNumber: number = new Date().getFullYear();
        let currentYearID = null;

        for (let yearEntity of years) {
            if (yearEntity.year > 0) {
                if (yearEntity.year == currentYearNumber) {
                    currentYearID = yearEntity.ID;
                }
                this.SelectBox_year.addEntry(yearEntity.ID, yearEntity.year_txt);
            }
        }

        let lastSelected = localStorage.getItem("lastselected__year");
        if (typeof (lastSelected) == "string" && lastSelected.length >= 17) { // mindestens eine ID. oder mehrfach..
            this.SelectBox_year.setValue(lastSelected);
        } else {
            if (currentYearID != null) {
                this.SelectBox_year.setValue(currentYearID);
            }
        }

        this.SelectBox_year.startup();

        this.loadWeeks(); // wochen erst laden wenn jahre da sind
        this.loadMonths();  // monate erst laden wenn jahre da sind
    }
    // #endregion

    // #region functional groups
    loadFunctionalGroups(): void {
        this.StandbyStart();

        let url = window.appRoot + "data/functionalgroups";
        this.RequestManager.post(
            url,
            {
                "JsonData": JSON.stringify({

                })
            },
            lang.hitch(this, this.loadFunctionalGroups_Response),
            lang.hitch(this, this.loadFunctionalGroups_Error)
        );
    }

    loadFunctionalGroups_Response(functionalGroups: Array<Entity_FunctionalGroup>): void {
        this.StandbyStop();
        this.functionalGroups = functionalGroups;

        this._renderFunctionalGroups(functionalGroups);
    }

    loadFunctionalGroups_Error(error): void {
        this.StandbyStop();
    }

    _renderFunctionalGroups(functionalGroups: Array<Entity_FunctionalGroup>): void {
        let SelectParent: Node = this.SelectBox_functionalGroups.domNode.parentNode;

        this.SelectBox_functionalGroups.destroy();
        this.SelectBox_functionalGroups = new SelectBox();
        this.SelectBox_functionalGroups.setLabel(this.getTranslation("OM_Matrix__lbl_FunctionalGroup"));
        this.SelectBox_functionalGroups.setBlankOption("XXX", this.getTranslation("OM_Matrix__lbl_SelectFunctionalGroup"));
        this.SelectBox_functionalGroups.setMultiselectHeight(8);
        this.SelectBox_functionalGroups.minCount = 1;
        this.SelectBox_functionalGroups.maxCount = 4;
        this.SelectBox_functionalGroups.setMultiselect(true);

        this.SelectBox_functionalGroups.placeAt(SelectParent);
        this.SelectBox_functionalGroups.on("valueChange", lang.hitch(this, "_onChange_FunctionalGroup"));

        for (let entity of functionalGroups) {
            this.SelectBox_functionalGroups.addEntry(entity.ID, entity.description, true);
        }

        let lastSelectedFunctionalGroup = localStorage.getItem("lastselected__functionalGroup");
        if (typeof (lastSelectedFunctionalGroup) == "string" && lastSelectedFunctionalGroup.length >= 17) { // mindestens eine ID. oder mehrfach..
            this.SelectBox_functionalGroups.setMultipleValues(lastSelectedFunctionalGroup.split(","), true, true);
        }

        this.SelectBox_functionalGroups.startup();
    }

    _onChange_FunctionalGroup(): void {
        localStorage.setItem("lastselected__functionalGroup", this.SelectBox_functionalGroups.getValue());
    }
    // #endregion

    // #region Month
    loadMonths(): void {
        this.StandbyStart();

        let year: string = null;
        let yearId: string = this.SelectBox_year.getValue();
        if (yearId != null && this.years != null) {
            for (var yearEntity of this.years) {
                if (yearEntity.ID == yearId) {
                    year = yearEntity.year_txt;
                }
            }

            let url = window.appRoot + "data/months";
            this.RequestManager.post(
                url,
                {
                    "JsonData": JSON.stringify({
                        "year": year
                    })
                },
                lang.hitch(this, this.loadMonths_Response),
                lang.hitch(this, this.loadMonths_Error)
            );
        }
    }

    loadMonths_Response(months: Array<Entity_Month>): void {
        this.StandbyStop();

        this._renderMonths(months);
    }

    loadMonths_Error(error): void {
        this.StandbyStop();
    }

    _onChange_Month(): void {
        localStorage.setItem("lastselected__month", this.SelectBox_month.getValue());
    }

    _renderMonths(months: Array<Entity_Month>): void {
        let monthSelectParent: Node = this.SelectBox_month.domNode.parentNode;

        this.SelectBox_month.destroy();
        this.SelectBox_month = new SelectBox();
        this.SelectBox_month.setLabel(this.getTranslation("OM_Matrix__lbl_Month"));
        this.SelectBox_month.setBlankOption("XXX", this.getTranslation("OM_Matrix__lbl_SelectMonth"));
        this.SelectBox_month.on("valueChange", lang.hitch(this, this._onChange_Month));

        this.SelectBox_month.placeAt(monthSelectParent);

        let currentmonthNumber = (new Date()).getMonth() + 1;
        let currentMonthID = null;

        for (let entity of months) {
            if (entity.month_int > 0) {
                if (entity.month_int == currentmonthNumber) {
                    currentMonthID = entity.ID;
                }
                this.SelectBox_month.addEntry(entity.ID, entity.month_txt);
            }
        }


        let lastSelected = localStorage.getItem("lastselected__month");
        if (typeof (lastSelected) == "string" && lastSelected.length >= 17) { // mindestens eine ID. oder mehrfach..
            this.SelectBox_month.setValue(lastSelected);
        } else {
            if (currentMonthID != null) {
                this.SelectBox_month.setValue(currentMonthID);
            }
        }

        this.SelectBox_month.startup();
    }
    // #endregion

    getWeekNumber(d: Date): number {
        // Copy date so don't modify original
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        // Get first day of year
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        // Return array of year and week number
        return weekNo;
    }

    private _handleSectionVisibility(): void {
        if (this.directBookingId || this.directProjectId) {
            this.UiModder.domClass.add(this.timeBasedFilterContainer, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.timeBasedFilterContainer, "w3-hide");
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.loadYears();
        this.loadFunctionalGroups();

        let directBookingId = this.getUrlParameterValue("directBookingId");
        let directProjectId = this.getUrlParameterValue("directProjectId");

        this._handleSectionVisibility();

        if (directBookingId || directProjectId) {
            this.directBookingId = directBookingId;
            this.directProjectId = directProjectId;
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //standardwert für timemode
        //
        this.RadioGroup_timeFilterMode.setValue("weeks");
        this.RadioGroup_timeFilterMode.setLabel(this.getTranslation("OM_Matrix__lbl_FilterBy"));

        this._handleSectionVisibility();
    }
}

export default mdsWidget(WeekSelector);
